import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import customButton from '@/components/ui/custom-button.vue'
import { useAuthStore } from '@/stores/authStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'signin-overlay',
  setup(__props) {

const AuthStore = useAuthStore()

const overlay = ref(false)
const firstName = ref('')
const lastName = ref('')

function saveAndClose () {
  AuthStore.setUserInfo({
    firstName: firstName,
    lastName: lastName
  })
  overlay.value = false
  AuthStore.setIsAuthenticated(true)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(customButton, {
      text: "Logga in",
      href: "/",
      refType: "genericButton",
      size: "small",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (overlay.value = !overlay.value)),
      class: "my-4"
    }),
    _createVNode(_component_v_overlay, {
      modelValue: overlay.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((overlay).value = $event)),
      contained: "",
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, { class: "pa-8" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: firstName.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
                  label: "Förnamn",
                  required: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: lastName.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
                  label: "Efternamn",
                  required: ""
                }, null, 8, ["modelValue"]),
                _createVNode(customButton, {
                  text: "Logga in",
                  href: "/",
                  refType: "genericButton",
                  size: "small",
                  onClick: saveAndClose
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})